export const ENABLE_WAITING = 'enableWaiting'
export const DISABLE_WAITING = 'disableWaiting'
export const OPEN_DELETE_DIALOG = 'openDeleteDialog'
export const UPDATE_DELETE_DIALOG = 'updateDeleteDialog'
export const CLOSE_DELETE_DIALOG = 'closeDeleteDialog'